<template>
  <v-container id="regular-forms" fluid tag="section">
    <base-material-card color="#ac8a2e" icon="mdi-run-fast" inline class="px-5 py-3" title="Jugadores en seguimiento">
      <template v-if="$can('M_scouting_edita')" v-slot:after-title>
        <v-btn color="#ac8a2e" dark icon @click="goToNewScoutingForm('new', 0)">
          <v-icon large color="#ac8a2e">
            mdi-account-plus
          </v-icon>
        </v-btn>
      </template>
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="search" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />
      <v-data-table
        :headers="headers"
        :items="scoutings"
        :search.sync="search"
        :sort-desc="[false, true]"
        multi-sort
        @click:row="showItem"
      >
        <template v-if="$can('M_scouting_edita')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToNewScoutingForm('edit', item.id)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        search: undefined,
        headers: [
          { text: 'Fecha', align: 'start', value: 'created_at' },
          { text: 'Nombre', value: 'nombre' },
          { text: 'Año', value: 'ano' },
          { text: 'Posición', value: 'posicion_detalle.descripcion' },
          { text: 'Club', value: 'club.descripcion' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        scoutings: [],
        editedIndex: -1,
        menu: false,
        dataForm: {
          id: '',
          nombre: '',
          ano: '',
          club_id: '',
          pierna_habil: '',
          contacto: '',
          agente: '',
          obs: '',
          pasaporte_id: '',
          posicion_detalle_id: '',
        },
      }
    },
    computed: {
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    created () {
      this.getScoutings()
    },
    methods: {

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/scouting_delete/' + item.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Baja de scouting exitosa'] })
          this.getScoutings()
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      getScoutings: async function () {
        this.$store.commit('loaderOn', 1)
        await this.$http.get('/api/scouting_get',
                             {
                               headers: { Authorization: 'Bearer ' + this.$store.state.token },
                             },
        ).then(response => {
          this.scoutings = response.data
        })
        this.$store.commit('loaderOff')
      },

      showItem (item) {
        this.goToNewScoutingForm('show', item.id)
      },

      goToNewScoutingForm: function (modeVal, idUser) {
        this.$router.push({ name: 'Alta Scouting', params: { mode: modeVal, id: idUser } })
      },
    },
  }
</script>
